export enum SampleDataGeneratingStatus {
  Started = 'started',
  Finished = 'finished',
  Failed = 'failed',
}

export enum CompanyStatus {
  Active = 'active',
  Blocked = 'blocked',
  Closed = 'closed',
  DeletionRequests = 'deletion_requests',
  Expired = 'expired',
}
